function getIphoneTypeFromCollectionPath(pathname) {
  var pathParts = pathname.split("/").filter(Boolean);
  var collectionIndex = pathParts.indexOf("collections");

  if (collectionIndex === -1 || !pathParts[collectionIndex + 1]) return null;

  var collectionHandle = decodeURIComponent(pathParts[collectionIndex + 1]).toLowerCase();
  var iphoneMarkerIndex = collectionHandle.indexOf("iphone-");

  if (iphoneMarkerIndex === -1) return null;

  var modelSlug = collectionHandle.slice(iphoneMarkerIndex + 7);
  var aliases = [
    ["16e", "iPhone 16e / 17e"],
    ["17e", "iPhone 16e / 17e"],
    ["12-12-pro", "iPhone 12 / 12 Pro"],
    ["xs-max", "iPhone XS Max"],
    ["xr", "iPhone XR"],
    ["xs", "iPhone X / XS"],
    ["x", "iPhone X / XS"],
    ["7-plus", "iPhone 6 / 7 / 8 Plus"],
    ["8-plus", "iPhone 6 / 7 / 8 Plus"],
    ["7", "iPhone 7 / 8 / SE"],
    ["8", "iPhone 7 / 8 / SE"],
    ["se", "iPhone 7 / 8 / SE"]
  ];
  var alias = aliases.find(function (entry) {
    return modelSlug === entry[0] || modelSlug.indexOf(entry[0] + "-") === 0;
  });

  if (alias) return alias[1];

  var modelMatch = modelSlug.match(/^(\d+)(e)?(?:-(pro-max|pro|plus|air|mini))?(?:-|$)/);

  if (!modelMatch) return null;

  var suffixLabels = {
    "pro-max": "Pro Max",
    pro: "Pro",
    plus: "Plus",
    air: "Air",
    mini: "Mini"
  };
  var model = "iPhone " + modelMatch[1] + (modelMatch[2] || "");

  if (modelMatch[3]) model += " " + suffixLabels[modelMatch[3]];

  return model;
}

var collectionIphoneType = getIphoneTypeFromCollectionPath(window.location.pathname);

if (collectionIphoneType) {
  localStorage.setItem("iphoneType", collectionIphoneType);
}

var iphoneType = localStorage.getItem("iphoneType");

document.addEventListener("variant:change", (event) => {
  var variant = event.detail.variant;
  var iphoneOption = (variant && variant.options || []).find(function (option) {
    return /^iphone\b/i.test((option || "").trim());
  });

  if (iphoneOption) {
    localStorage.setItem("iphoneType", iphoneOption);
    iphoneType = iphoneOption;
  }
});

var options = document.querySelectorAll(
  ".variant-picker__option .popover__value-list button"
);

setTimeout(function () {
  if (iphoneType != "" || iphoneType != null) {
    options.forEach((option) => {
      var title = option.querySelector("span").textContent;
      if (iphoneType == title) {
        option.click();
      }
    });
  }
}, 1000);


/* Code pour actualiser le texte de disponibilité lorsque l'on change de variante */

async function updateAvailability(section_id) {
  const url = new URL(window.location.href);
  const sectionId = section_id;

  try {
    const response = await fetch(`${url.pathname}?${url.searchParams.toString()}&section_id=${sectionId}`);
    const data = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    const newAvailabilityText = doc.querySelector('.product-info_availability-text');

    if (newAvailabilityText) {
      document.querySelector('.product-info_availability-text').innerHTML = newAvailabilityText.innerHTML;
    }
  } catch (error) {
    console.error('Error fetching availability information:', error);
  }
}

document.addEventListener("variant:change", async () => {
  const section_id = document.querySelector('variant-picker').dataset.sectionId;
  await updateAvailability(section_id);
});


/* Ouvre le sélecteur de variante quand on clique sur "Choisissez votre modèle" sans iPhone sélectionné */
(function () {
  function initChooseModelHandler() {
    if (localStorage.getItem('iphoneType')) return;

    var productForm = document.querySelector('form[is="product-form"]');
    if (!productForm) return;

    var idInput = productForm.querySelector('input[name="id"]');
    if (!idInput || idInput.value) return;

    var submitBtn = productForm.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    submitBtn.removeAttribute('disabled');

    submitBtn.addEventListener('click', function (e) {
      if (localStorage.getItem('iphoneType')) return;

      e.preventDefault();
      e.stopPropagation();

      var variantSection = document.querySelector('.variant-picker__option');
      var trigger = document.querySelector(
        '.variant-picker__option button[aria-haspopup], .variant-picker__option .popover-trigger, .variant-picker__option summary'
      );

      if (variantSection) {
        variantSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      setTimeout(function () {
        if (trigger) trigger.click();
      }, 350);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChooseModelHandler);
  } else {
    initChooseModelHandler();
  }
})();


/* Variation swatches : swap image + badges au hover, clic sans navigation */
(function () {
  function initVariationSwatches() {
    document.querySelectorAll('product-card').forEach(function (card) {
      var swatches = card.querySelectorAll('[data-var-img]');
      if (!swatches.length) return;

      var img = card.querySelector('.product-card__image--primary');
      if (!img) return;

      var figure = card.querySelector('.product-card__figure');

      function applyVariation(swatch) {
        img.srcset = '';
        img.src = swatch.dataset.varImg;

        var secondaryImg = card.querySelector('.product-card__image--secondary');
        if (secondaryImg && swatch.dataset.varSecondaryImg) {
          secondaryImg.srcset = '';
          secondaryImg.src = swatch.dataset.varSecondaryImg;
        }

        var link = swatch.querySelector('a');
        if (link) {
          card.querySelectorAll('a.product-card__media, a.product-title').forEach(function (productLink) {
            productLink.href = link.href;
          });
        }

        var quickBuySlot = card.querySelector('[data-product-card-quick-buy]');
        var quickBuyTemplate = swatch.querySelector('template.var-quick-buy-tpl');
        if (quickBuySlot && quickBuyTemplate && quickBuySlot.dataset.currentHandle !== swatch.dataset.varHandle) {
          quickBuySlot.replaceChildren(document.importNode(quickBuyTemplate.content, true));
          quickBuySlot.dataset.currentHandle = swatch.dataset.varHandle;
        }
        if (swatch.dataset.varHandle) card.setAttribute('handle', swatch.dataset.varHandle);

        var titleEl = card.querySelector('a.product-title');
        if (titleEl && swatch.dataset.varTitle) titleEl.textContent = swatch.dataset.varTitle;

        var varPrice = parseInt(swatch.dataset.varPrice, 10);
        if (varPrice) {
          var priceList = card.querySelector('price-list');
          var saleEl = priceList && priceList.querySelector('sale-price');
          var compareEl = priceList && priceList.querySelector('compare-at-price');
          var promotionActive = priceList && priceList.dataset.globalPromotionActive === 'true';
          var promotionPercentage = parseInt(priceList && priceList.dataset.globalPromotionPercentage, 10) || 0;
          var compareAtPrice = parseInt(swatch.dataset.varCompareAtPrice, 10) || 0;

          if (saleEl) {
            var displayedPrice = promotionActive
              ? Math.round(varPrice * (100 - promotionPercentage) / 100)
              : varPrice;
            saleEl.lastChild.replaceWith(
              document.createRange().createContextualFragment(formatSoldesPrice(displayedPrice))
            );
            saleEl.classList.toggle('text-on-sale', promotionActive || compareAtPrice > varPrice);
            saleEl.classList.toggle('text-subdued', !promotionActive && compareAtPrice <= varPrice);
          }
          if (compareEl) {
            var displayedCompareAtPrice = promotionActive ? varPrice : compareAtPrice;
            if (displayedCompareAtPrice > varPrice || promotionActive) {
              compareEl.lastChild.replaceWith(
                document.createRange().createContextualFragment(formatSoldesPrice(displayedCompareAtPrice))
              );
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
        }

        if (!figure) return;
        var template = swatch.querySelector('template.var-badges-tpl');
        var currentBadgeList = figure.querySelector('badge-list');
        var newBadgesHTML = '';

        if (template) {
          var tmp = document.createElement('div');
          tmp.appendChild(template.content.cloneNode(true));
          newBadgesHTML = tmp.innerHTML.trim();
        }

        if (currentBadgeList) {
          if (newBadgesHTML) {
            currentBadgeList.outerHTML = newBadgesHTML;
          } else {
            currentBadgeList.remove();
          }
        } else if (newBadgesHTML) {
          figure.insertAdjacentHTML('afterbegin', newBadgesHTML);
        }
      }

      swatches.forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function () {
          applyVariation(swatch);
        });

        swatch.addEventListener('click', function (e) {
          e.preventDefault();

          applyVariation(swatch);

          var link = swatch.querySelector('a');
          var varUrl = link ? link.href : '';
          if (!varUrl) return;

          card.querySelectorAll('[data-var-img] a.color-swatch').forEach(function (a) {
            a.classList.remove('is-selected');
          });
          if (link) link.classList.add('is-selected');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariationSwatches);
  } else {
    initVariationSwatches();
  }
})();


/* Utilitaire partagé : formatage monétaire pour les prix promotionnels */
function formatSoldesPrice(cents) {
  var vars = window.themeVariables && window.themeVariables.settings;
  if (!vars) return '';
  var fmt = vars.currencyCodeEnabled ? vars.moneyWithCurrencyFormat : vars.moneyFormat;
  var amount = cents / 100;
  return fmt
    .replace('{{amount}}', amount.toFixed(2))
    .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
    .replace('{{amount_no_decimals}}', Math.round(amount).toString())
    .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount).toString());
}

/* Maintenir le prix promotionnel configuré après chaque changement de variante */
(function () {
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail.variant;

    setTimeout(function () {
      var priceList = document.querySelector('.price-list--product');
      if (!priceList) return;
      if (priceList.dataset.globalPromotionActive !== 'true') return;

      var salePrice = priceList.querySelector('sale-price');
      var compareAtPrice = priceList.querySelector('compare-at-price');
      if (!salePrice) return;

      var promotionPercentage = parseInt(priceList.dataset.globalPromotionPercentage, 10) || 0;
      var discountedCents = Math.round(variant.price * (100 - promotionPercentage) / 100);

      salePrice.lastChild.replaceWith(
        document.createRange().createContextualFragment(formatSoldesPrice(discountedCents))
      );
      salePrice.classList.add('text-on-sale');
      salePrice.classList.remove('text-subdued');

      if (compareAtPrice) {
        compareAtPrice.lastChild.replaceWith(
          document.createRange().createContextualFragment(formatSoldesPrice(variant.price))
        );
        compareAtPrice.hidden = false;
      }
    }, 0);
  });
})();


/* Clic sur image produit → ouvre la lightbox (mobile < 1000px) */
(function () {
  function initTapToZoom() {
    var gallery = document.querySelector('product-gallery[allow-zoom]');
    if (!gallery) return;

    var zoomBtn = gallery.querySelector('.product-gallery__zoom-button');
    if (!zoomBtn) return;

    gallery.querySelectorAll('.product-gallery__media').forEach(function (media) {
      media.addEventListener('click', function () {
        if (window.innerWidth >= 1000) return;
        zoomBtn.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTapToZoom);
  } else {
    initTapToZoom();
  }
})();

(function () {
  var activeIphoneValue = null;
  var drawerPreloadGeneration = 0;
  var drawerPreloadImages = [];

  function sortColorDrawerItems(grid) {
    var items = Array.from(grid.querySelectorAll('.product-color-drawer__item'));

    items.sort(function (firstItem, secondItem) {
      var firstCurrent = firstItem.dataset.colorCurrent === 'true' || firstItem.getAttribute('aria-pressed') === 'true';
      var secondCurrent = secondItem.dataset.colorCurrent === 'true' || secondItem.getAttribute('aria-pressed') === 'true';

      if (firstCurrent !== secondCurrent) return firstCurrent ? -1 : 1;

      var firstUnavailable = firstItem.classList.contains('is-unavailable');
      var secondUnavailable = secondItem.classList.contains('is-unavailable');

      if (firstUnavailable !== secondUnavailable) return firstUnavailable ? 1 : -1;

      return 0;
    });

    items.forEach(function (item) {
      grid.appendChild(item);
    });
  }

  function scheduleDrawerImagePreload() {
    var generation = ++drawerPreloadGeneration;

    function queuePreload() {
      var preload = function () {
        if (generation !== drawerPreloadGeneration) return;

        var sources = Array.from(document.querySelectorAll('[data-color-drawer-image-src]'))
          .map(function (item) {
            return item.dataset.colorDrawerImageSrc;
          })
          .filter(function (source, index, allSources) {
            return source && allSources.indexOf(source) === index;
          });

        drawerPreloadImages = sources.map(function (source) {
          var image = new Image();
          image.decoding = 'async';
          image.src = source;
          return image;
        });
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preload, { timeout: 4000 });
      } else {
        window.setTimeout(preload, 1000);
      }
    }

    if (document.readyState === 'complete') {
      queuePreload();
    } else {
      window.addEventListener('load', queuePreload, { once: true });
    }
  }

  function updateColorImagesForIphone(iphoneValue, drawerToLoad) {
    if (!iphoneValue) return;

    activeIphoneValue = iphoneValue;

    var imageMaps = {};

    document.querySelectorAll('[data-color-image-map]').forEach(function (script) {
      try {
        imageMaps[script.dataset.colorImageMap] = JSON.parse(script.textContent);
      } catch (error) {
        imageMaps[script.dataset.colorImageMap] = [];
      }
    });

    document.querySelectorAll('[data-color-image-product]').forEach(function (item) {
      var variants = imageMaps[item.dataset.colorImageProduct];
      if (!variants || variants.length === 0) return;

      var colorPosition = Number(item.dataset.colorImageOptionPosition || 0);
      var colorValue = item.dataset.colorImageOptionValue;
      var matchingVariant = variants.find(function (variant) {
        var options = variant.options || [];

        if (options.indexOf(iphoneValue) === -1) return false;
        if (colorPosition && colorValue && options[colorPosition - 1] !== colorValue) return false;

        return true;
      });
      var image = item.querySelector('img');

      var isAvailable = Boolean(matchingVariant && matchingVariant.available);
      var unavailableLabel = item.querySelector('[data-color-unavailable-label]');

      item.classList.toggle('is-unavailable', !isAvailable);

      if (unavailableLabel) unavailableLabel.hidden = isAvailable;
      if (!matchingVariant || !image) return;

      var itemDrawer = item.closest('x-drawer.product-color-drawer');
      var imageSource = itemDrawer ? matchingVariant.drawer_src : matchingVariant.preview_src;

      if (!imageSource) return;

      if (itemDrawer) item.dataset.colorDrawerImageSrc = matchingVariant.drawer_src;

      if (itemDrawer && itemDrawer !== drawerToLoad) {
        item.dataset.colorPendingImageSrc = imageSource;
        item.dataset.colorPendingImageAlt = matchingVariant.alt || '';
        return;
      }

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = imageSource;
      delete item.dataset.colorPendingImageSrc;
      delete item.dataset.colorPendingImageAlt;

      if (matchingVariant.alt) image.alt = matchingVariant.alt;
    });

    document.querySelectorAll('.product-color-drawer__grid').forEach(sortColorDrawerItems);

    if (!drawerToLoad) scheduleDrawerImagePreload();
  }

  function showSelectedColorPreview(previewItem) {
    var previewList = previewItem && previewItem.closest('[data-option-selector]');
    if (!previewList) return;

    previewList.prepend(previewItem);
    previewList.querySelectorAll('[data-color-preview-item]').forEach(function (item, index) {
      item.classList.toggle('is-hidden', index >= 5);
      item.classList.toggle('is-desktop-hidden', index >= 4 && Boolean(previewList.querySelector('.product-color-preview__more')));
    });
  }

  document.addEventListener('click', function (event) {
    var drawerTrigger = event.target.closest('.product-color-drawer__trigger, .product-color-preview__more');
    if (drawerTrigger && activeIphoneValue) {
      var controlledDrawer = document.getElementById(drawerTrigger.getAttribute('aria-controls'));

      if (controlledDrawer) {
        window.setTimeout(function () {
          updateColorImagesForIphone(activeIphoneValue, controlledDrawer);
        }, 0);
      }
    }

    var drawerLink = event.target.closest('[data-color-drawer-link]');
    if (drawerLink) {
      var drawer = drawerLink.closest('x-drawer');
      if (drawer && typeof drawer.hide === 'function') drawer.hide();
      return;
    }

    var colorChoice = event.target.closest('[data-color-option-target]');
    if (!colorChoice) return;

    var targetId = colorChoice.getAttribute('data-color-option-target');
    var targetInput = document.getElementById(targetId);
    if (!targetInput || targetInput.disabled) return;

    targetInput.checked = true;
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    var previewItem = event.target.closest('[data-color-preview-item]');
    if (!previewItem || !event.target.checked) return;

    showSelectedColorPreview(previewItem);
  });

  document.addEventListener('variant:change', function (event) {
    var formId = event.target.getAttribute && (event.target.getAttribute('form') || event.target.getAttribute('id'));
    if (!formId || !event.detail.variant) return;

    var iphoneValue = (event.detail.variant.options || []).find(function (value) {
      return /^iphone\b/i.test(value);
    });

    updateColorImagesForIphone(iphoneValue);

    document.querySelectorAll('[data-color-preview-form="' + CSS.escape(formId) + '"]').forEach(function (previewItem) {
      var optionIndex = Number(previewItem.dataset.colorPreviewPosition) - 1;
      var isSelected = event.detail.variant.options[optionIndex] === previewItem.dataset.colorPreviewValue;

      if (isSelected) {
        showSelectedColorPreview(previewItem);
      }
    });

    document.querySelectorAll('[data-color-option-form="' + CSS.escape(formId) + '"]').forEach(function (choice) {
      var optionIndex = Number(choice.dataset.colorOptionPosition) - 1;
      var isSelected = event.detail.variant.options[optionIndex] === choice.dataset.colorOptionValue;
      choice.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    document.querySelectorAll('.product-color-drawer__grid').forEach(sortColorDrawerItems);
  });

  scheduleDrawerImagePreload();
})();
// ReelUp only scans the initial document. Quick-buy app blocks arrive later.
(function initializeQuickBuyReelUp() {
  const selector = '.reelUp_product_slider_static';
  const initialized = new WeakSet();
  let queue = Promise.resolve();
  const pause = () => new Promise(resolve => window.setTimeout(resolve, 100));

  function waitUntilVisible(widget, modal) {
    return new Promise(resolve => {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) finish(true);
      }, { threshold: 0.01 });
      const closed = () => finish(false);
      function finish(visible) {
        observer.disconnect();
        modal.removeEventListener('dialog:after-hide', closed);
        resolve(visible);
      }
      modal.addEventListener('dialog:after-hide', closed, { once: true });
      observer.observe(widget);
    });
  }

  async function initialize(modal) {
    const widgets = Array.from(modal.querySelectorAll(selector));
    const pending = widgets.filter(widget => !widget.dataset.rendered && !initialized.has(widget));
    if (!pending.length) return;

    // A customer can open quick buy before the asynchronously loaded app is ready.
    const deadline = Date.now() + 20000;
    while (typeof window.REELUP?.executeApp !== 'function') {
      if (!modal.isConnected || !modal.hasAttribute('open') || Date.now() > deadline) return;
      await pause();
    }
    if (!modal.hasAttribute('open')) return;
    // Keep the app's lazy loading: do not fetch video code until its block is visible.
    if (!await waitUntilVisible(pending[0], modal)) return;

    // The app takes its product video IDs from global data rather than the modal.
    const reelIds = [...new Set(pending.flatMap(widget =>
      Array.from(widget.querySelectorAll('[data-reel-id]'), slide => Number(slide.dataset.reelId))
    ))].filter(Number.isFinite);
    if (!reelIds.length) return;
    const app = window.REELUP;
    const hadProductReels = Object.prototype.hasOwnProperty.call(app, 'productReels');
    const previousProductReels = app.productReels;
    try {
      app.productReels = reelIds;
      await app.executeApp();
      // executeApp also touches existing widgets; retain their completed state.
      document.querySelectorAll('[data-rendered="true"].reelUp-loading-skeleton')
        .forEach(widget => widget.classList.remove('reelUp-loading-skeleton'));
      const renderDeadline = Date.now() + 15000;
      while (pending.some(widget => !widget.querySelector('video, .reelUp_carousel_list')) &&
             modal.isConnected && modal.hasAttribute('open') && Date.now() < renderDeadline) {
        await pause();
      }
      pending.forEach(widget => {
        if (widget.querySelector('video, .reelUp_carousel_list')) initialized.add(widget);
      });
    } finally {
      if (app.productReels === reelIds) {
        if (hadProductReels) app.productReels = previousProductReels;
        else delete app.productReels;
      }
    }
  }

  // Dialog events do not bubble in Prestige, so listen during capture.
  document.addEventListener('dialog:after-show', event => {
    if (!event.target.matches('quick-buy-modal, quick-buy-modal-bundle')) return;
    queue = queue.then(() => initialize(event.target)).catch(error => {
      console.warn('ReelUp quick buy could not initialize:', error);
    });
  }, true);
})();
